export function initBuyNow() {
  document.addEventListener('click', function(e) {
    if (!e.target.classList.contains('buy-now-btn')) return;

    e.preventDefault();

    const button = e.target;
    const variationId = button.getAttribute('data-variation-id');
    const nonce = button.getAttribute('data-nonce');

    if (!variationId || !nonce) {
      alert('Invalid product data. Please refresh the page and try again.');
      return;
    }

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Processing...';

    const formData = new FormData();
    formData.append('action', 'wpbuoy_buy_now');
    formData.append('variation_id', variationId);
    formData.append('nonce', nonce);

    fetch(wpbuoy_ajax.ajax_url, { method: 'POST', body: formData })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          window.location.href = data.data.redirect_url;
        } else {
          alert(data.data.message || 'An error occurred. Please try again.');
          button.disabled = false;
          button.textContent = originalText;
        }
      })
      .catch(() => {
        alert('A network error occurred. Please try again.');
        button.disabled = false;
        button.textContent = originalText;
      });
  });
}
